import { fork } from 'redux-saga/effects';
import { executorsWatcher } from './executorsSaga';
import { filtersConfigWatcher } from './filtersSaga';
import { executorCardWatcher } from './executorCardSaga';

export default function* Templates() {
  yield fork(executorsWatcher);
  yield fork(filtersConfigWatcher);
  yield fork(executorCardWatcher);
}
